import { FC } from 'react';
import { Avatar } from '@chakra-ui/react';

import SunshineCard from 'components/_core/SunshineCard';

import { BankTransferRecipient } from '../../types';
import BeneficiaryDetails from '../BeneficiaryDetails';

interface BeneficiaryRowProps {
  beneficiary: BankTransferRecipient;
  onClick: () => void;
}

const BeneficiaryRow: FC<BeneficiaryRowProps> = ({ beneficiary, onClick }) => {
  return (
    <SunshineCard onClick={onClick}>
      <SunshineCard.Slot name="aside">
        <Avatar
          backgroundColor="grey.200"
          borderRadius="radius-12"
          color="grey.800"
          fontWeight="weight-500"
          name={beneficiary.label || beneficiary.name}
          size="md"
        />
      </SunshineCard.Slot>
      <BeneficiaryDetails beneficiary={beneficiary} />

      <SunshineCard.Slot name="action">
        <SunshineCard.SunshineIcon name="chevron-right" />
      </SunshineCard.Slot>
    </SunshineCard>
  );
};

export default BeneficiaryRow;
